import { ShapeType } from '@/shared/api/BaseAPI.model'
import SquareTemplate from '../templates/SquareTemplate/SquareTemplate'
import RoundTemplate from '../templates/RoundTemplate/RoundTemplate'
import RectangleVerticalTemplate from '../templates/RectangleVerticalTemplate/RectangleVerticalTemplate'
import RectangleVerticalCenteredTemplate from '../templates/RectangleVerticalCenteredTemplate/RectangleVerticalCenteredTemplate'
import RectangleHorizontalTemplate from '../templates/RectangleHorizontalTemplate/RectangleHorizontalTemplate'
import RectangleHorizontalCenteredTemplate from '../templates/RectangleHorizontaleCenteredTemplate/RectangleHorizontalCenteredTemplate'

interface TableCardPreviewProps {
  tableNumber?: number
  /** URL the QR encodes; rendered on the frontend (see TableCardQrCode). */
  qrCodeValue?: string
  withNfc?: boolean
  languageCode?: 'en' | 'pl'
  logoImageUrl: string
  shape: ShapeType
  align?: 'left' | 'center'
  backgroundColorValue?: string
  contentColor?: string
  contrastColor?: string
  backgroundImage?: string | null
  width: number
  height: number
}

function getTableCardPreview(props: TableCardPreviewProps) {
  const {
    tableNumber = 73,
    qrCodeValue,
    withNfc = false,
    languageCode = 'en',
    logoImageUrl,
    shape,
    align = 'left',
    backgroundColorValue = 'ff6500',
    contentColor = '#FFFFFF',
    contrastColor = 'rgba(0, 0, 0, 0.3)',
    backgroundImage = null,
    width,
    height
  } = props

  switch (shape) {
    case 'square':
      return (
        <SquareTemplate
          tableNumber={tableNumber}
          logoImageUrl={logoImageUrl}
          languageCode={languageCode}
          withNfc={withNfc}
          qrCodeValue={qrCodeValue}
          backgroundColorValue={backgroundColorValue}
          contentColor={contentColor}
          contrastColor={contrastColor}
          backgroundImage={backgroundImage}
          width={width}
          height={height}
        />
      )
    case 'circle':
      return (
        <RoundTemplate
          tableNumber={tableNumber}
          logoImageUrl={logoImageUrl}
          languageCode={languageCode}
          withNfc={withNfc}
          qrCodeValue={qrCodeValue}
          backgroundColorValue={backgroundColorValue}
          contentColor={contentColor}
          contrastColor={contrastColor}
          backgroundImage={backgroundImage}
          width={width}
          height={height}
        />
      )
    case 'verticalRectangle':
      switch (align) {
        case 'left':
          return (
            <RectangleVerticalTemplate
              tableNumber={tableNumber}
              logoImageUrl={logoImageUrl}
              withNfc={withNfc}
              languageCode={languageCode}
              qrCodeValue={qrCodeValue}
              backgroundColorValue={backgroundColorValue}
              contentColor={contentColor}
              contrastColor={contrastColor}
              backgroundImage={backgroundImage}
              width={width}
              height={height}
            />
          )
        case 'center':
          return (
            <RectangleVerticalCenteredTemplate
              tableNumber={tableNumber}
              logoImageUrl={logoImageUrl}
              withNfc={withNfc}
              languageCode={languageCode}
              qrCodeValue={qrCodeValue}
              backgroundColorValue={backgroundColorValue}
              contentColor={contentColor}
              contrastColor={contrastColor}
              backgroundImage={backgroundImage}
              width={width}
              height={height}
            />
          )
        default:
          return (
            <RectangleVerticalTemplate
              tableNumber={tableNumber}
              logoImageUrl={logoImageUrl}
              withNfc={withNfc}
              languageCode={languageCode}
              qrCodeValue={qrCodeValue}
              backgroundColorValue={backgroundColorValue}
              contentColor={contentColor}
              contrastColor={contrastColor}
              backgroundImage={backgroundImage}
              width={width}
              height={height}
            />
          )
      }
    case 'horizontalRectangle':
      switch (align) {
        case 'left':
          return (
            <RectangleHorizontalTemplate
              tableNumber={tableNumber}
              logoImageUrl={logoImageUrl}
              withNfc={withNfc}
              languageCode={languageCode}
              qrCodeValue={qrCodeValue}
              backgroundColorValue={backgroundColorValue}
              contentColor={contentColor}
              contrastColor={contrastColor}
              backgroundImage={backgroundImage}
              width={width}
              height={height}
            />
          )
        case 'center':
          return (
            <RectangleHorizontalCenteredTemplate
              tableNumber={tableNumber}
              logoImageUrl={logoImageUrl}
              withNfc={withNfc}
              languageCode={languageCode}
              qrCodeValue={qrCodeValue}
              backgroundColorValue={backgroundColorValue}
              contentColor={contentColor}
              contrastColor={contrastColor}
              backgroundImage={backgroundImage}
              width={width}
              height={height}
            />
          )

        default:
          return (
            <RectangleHorizontalTemplate
              tableNumber={tableNumber}
              logoImageUrl={logoImageUrl}
              withNfc={withNfc}
              languageCode={languageCode}
              qrCodeValue={qrCodeValue}
              backgroundColorValue={backgroundColorValue}
              contentColor={contentColor}
              contrastColor={contrastColor}
              backgroundImage={backgroundImage}
              width={width}
              height={height}
            />
          )
      }
    default:
      return (
        <RectangleHorizontalTemplate
          tableNumber={tableNumber}
          logoImageUrl={logoImageUrl}
          withNfc={withNfc}
          languageCode={languageCode}
          qrCodeValue={qrCodeValue}
          backgroundColorValue={backgroundColorValue}
          contentColor={contentColor}
          contrastColor={contrastColor}
          backgroundImage={backgroundImage}
          width={width}
          height={height}
        />
      )
  }
}

export default getTableCardPreview
